import { type Colors } from '@factorialco/deprecated-design-system'
import { ShiftManagementTemplateWeeksQuery } from 'generated/resources/graphql'

import { getColor } from 'modules/shift_management/lib/getColor'

export type TTemplateWeek =
  ShiftManagementTemplateWeeksQuery['shiftManagement']['templateWeeks'][number]

export interface ITemplateWeek {
  id: number
  name: string
  template_id: number
  position: number
  color: string | null
  template_name: string
  archived: boolean
}
export interface Props {
  id: number
  templateId: number
  name: string
  position: number
  color: Colors | null
  templateName: string
  archived: boolean
}
class TemplateWeek {
  id: number
  templateId: number
  name: string
  position: number
  color: Colors | null
  templateName: string
  archived: boolean

  constructor(props: Props) {
    this.id = props.id
    this.templateId = props.templateId
    this.name = props.name
    this.position = props.position
    this.color = props.color
    this.templateName = props.templateName
    this.archived = props.archived
  }

  /**
   * @deprecated Before using this method, consider using the `buildFromGraphQL` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  static buildFromProps(templateWeek: ITemplateWeek): TemplateWeek {
    const color = getColor(templateWeek.color)

    return new TemplateWeek({
      id: templateWeek.id,
      templateId: templateWeek.template_id,
      name: templateWeek.name,
      position: templateWeek.position,
      color,
      templateName: templateWeek.template_name,
      archived: templateWeek.archived,
    })
  }

  static buildFromGraphQL(templateWeek: TTemplateWeek): TemplateWeek {
    const color = getColor(templateWeek.color)

    return new TemplateWeek({
      id: templateWeek.id,
      templateId: templateWeek.templateId,
      name: templateWeek.name,
      position: templateWeek.position,
      color,
      templateName: templateWeek.templateName,
      archived: templateWeek.archived,
    })
  }
}

export default TemplateWeek
